<div class="quick-panel-custom h-100-p w-100-p">
    <div fxLayout="column" fxLayoutAlign="center center" class="h-100-p">
            <div class="grid-row" >
                    <div class="col bg">
                            <div class="app-loading">
                                    <!-- <img width="180" src="./assets/loader.gif" width="80"/> -->
                                    <svg class="svg-loading" viewBox="-2000 -1000 4000 2000">
                                            <path id="inf" d="M354-354A500 500 0 1 1 354 354L-354-354A500 500 0 1 0-354 354z"></path>
                                            <use xlink:href="#inf" stroke-dasharray="1570 5143" stroke-dashoffset="6713px"></use>
                                    </svg>
                            </div>
                            
                            </div>
                </div>
    </div>
</div>
<!--  
                    [ngStyle]="{'background-image': backgroundImage}" -->